import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react'
import { ThemeProvider } from '@material-ui/core'

import { darkTheme } from '../../styles/theme/v4/darkTheme'
import { lightTheme } from '../../styles/theme/v4/lightTheme'

interface ThemeContextProps {
  themeName: string
  toggleThemeV4: () => void
}

interface ThemeProviderProps {
  children: ReactNode
}

const ThemeContext = createContext({} as ThemeContextProps)

const AppThemeProviderV4 = ({ children }: ThemeProviderProps) => {
  const [themeName, setThemeName] = useState<'light' | 'dark'>('light')

  const toggleThemeV4 = useCallback(() => {
    setThemeName(oldTheme => (oldTheme === 'light' ? 'dark' : 'light'))
  }, [])

  const theme = useMemo(() => {
    return themeName === 'light' ? lightTheme : darkTheme
  }, [themeName])

  return (
    <ThemeContext.Provider value={{ themeName, toggleThemeV4 }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  )
}

const useThemeV4 = () => {
  const context = useContext(ThemeContext)

  return context
}

export { AppThemeProviderV4, useThemeV4 }
